import { Svg } from '../svg';
import { IconType } from '../../models';
import { theme } from '../../styles/theme';

export const IconYoutube: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 31 31">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3294 16.7273C14.1676 16.0785 14.2817 15.1076 14.2774 14.3635C14.2716 13.4648 14.0375 12.777 14.8728 13.1715C15.8064 13.6136 17.2039 14.5282 18.1187 14.8287C17.8731 15.3373 18.3037 14.9068 17.6592 15.2998C17.5161 15.3864 17.3528 15.4428 17.2155 15.5107C16.3643 15.9398 14.7977 17.0032 14.3294 16.7258V16.7273ZM9.18886 14.1034C9.18886 16.3834 8.81166 19.1387 10.8277 19.6155C12.2715 19.958 18.9411 19.8554 20.577 19.6589C22.2607 19.4566 22.5598 17.9872 22.5598 16.4686C22.5598 10.5086 23.1047 10.3121 15.818 10.4046C14.1676 10.4248 12.39 10.3425 10.8292 10.5895C9.3565 10.8236 9.18886 12.4837 9.18886 14.1034Z"
      fill={theme.colors.text}
    />
    <circle cx="15.865" cy="15.1152" r="14.25" stroke={theme.colors.text} strokeWidth="1.5" />
  </Svg>
);
